import { createEmitter } from "@codesuma/baseline";
import { AppEventMap } from "../types";

export const emitter = createEmitter<AppEventMap>();